
import { defineComponent, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { MenuComponent } from "@/assets/ts/components";
import { ApiBrands } from "@/core/api";
import mixin from "@/mixins";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default defineComponent({
  name: "brand-information",
  components: {},
  setup() {
    const loading = ref<boolean>(false);
    const formRef = ref<null | HTMLFormElement>(null);
    const submitButton = ref<HTMLElement | null>(null);
    const deleteButton = ref<HTMLElement | null>(null);
    const route = useRoute();
    const router = useRouter();
    const {
      showValidateErrorMsg,
      showFormSubmitSuccessMsg,
      showServerErrorMsg,
    } = mixin();

    const formData = ref({
      id: route.params.id,
      status: 10,
      name: "",
      logo: "",
      description: "",
      seo_title: "",
      seo_description: "",
      short_key: "",
      website: "",
    });

    const rules = ref({
      name: [
        {
          required: true,
          message: "Brand Name is required",
          trigger: "change",
        },
      ],
      short_key: [
        {
          required: true,
          message: "Brand Short-Key is required",
          trigger: "change",
        },
      ],

      description: [
        {
          required: true,
          message: "Description is required",
          trigger: "change",
        },
      ],
      seo_title: [
        {
          required: true,
          message: "Seo Title is required",
          trigger: "change",
        },
      ],
      seo_description: [
        {
          required: true,
          message: "Seo Description is required",
          trigger: "change",
        },
      ],
    });

    const details = ref({
      name: "",
      website: "",
    });
    const getBrandData = () => {
      loading.value = true;
      ApiBrands.getBrandsInfo({ id: route.params.id })
        .then(({ data }) => {
          loading.value = false;
          if (data.code == 0) {
            formData.value = data.data;
            let { name, website } = JSON.parse(JSON.stringify(formData.value));
            details.value = {
              name,
              website,
            };
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const deleteBrand = () => {
      Swal.fire({
        text: "Are you sure you would like to deactivate your Brand?",
        icon: "warning",
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          if (deleteButton.value) {
            deleteButton.value.setAttribute("data-kt-indicator", "on");
          }
          loading.value = true;
          ApiBrands.deleteBrands({ id: route.params.id })
            .then(({ data }) => {
              loading.value = false;
              deleteButton.value?.removeAttribute("data-kt-indicator");
              if (data.code == 0) {
                Swal.fire({
                  text: "Your Group has been deactivated!",
                  icon: "success",
                  buttonsStyling: false,
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then(() => {
                  router.push({ name: "brands" });
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    };

    const submit = () => {
      if (!formRef.value) {
        return;
      }
      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;
          if (submitButton.value) {
            submitButton.value.setAttribute("data-kt-indicator", "on");
          }
          ApiBrands.updateBrands(formData.value)
            .then(({ data }) => {
              loading.value = false;
              submitButton.value?.removeAttribute("data-kt-indicator");
              if (data.code == 0) {
                showFormSubmitSuccessMsg();
                let { name, website } = JSON.parse(
                  JSON.stringify(formData.value)
                );
                details.value = {
                  name,
                  website,
                };
              } else {
                showServerErrorMsg(data);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          showValidateErrorMsg();
          return false;
        }
      });
    };

    onMounted(() => {
      MenuComponent.reinitialization();
      setCurrentPageBreadcrumbs("Information", ["Brand"]);
      getBrandData();
    });

    return {
      loading,
      details,
      formData,
      rules,
      formRef,
      submitButton,
      deleteButton,
      submit,
      getBrandData,
      deleteBrand,
    };
  },
});
